module.exports = __webpack_public_path__ + "img/login_logo.1a3add20.png";